import {CreateRequestMobile} from './mobile';

export const CreateRequest = CreateRequestMobile;
